import { ResidentReportsScreen } from "app/screens/residents/show/ResidentReportsScreen";

export default function ResidentReportsPage() {
  return <ResidentReportsScreen />;
}
